import type { FC } from 'react';
import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';

import { InfoIcon } from '@/assets';
import { Row } from '@/shared/components/layout/Row';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

type Props = {
  message: string;
  maxWidth?: number;
};

export const AspectRatioWarning: FC<Props> = ({ message, maxWidth }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme, maxWidth), [theme, maxWidth]);

  return (
    <Row style={styles.hint}>
      <InfoIcon fill={theme.colors.primary} width={18} height={18} />
      <Text variant="bodySmall" style={styles.hintText}>
        {message}
      </Text>
    </Row>
  );
};

const makeStyles = (theme: AppTheme, maxWidth?: number) =>
  StyleSheet.create({
    hint: {
      alignItems: 'center',
      gap: 10,
      paddingVertical: 10,
      paddingHorizontal: 12,
      borderLeftWidth: 3,
      borderLeftColor: theme.colors.primary,
      borderRadius: 6,
      backgroundColor: theme.colors.surfaceVariant,
      ...(maxWidth ? { maxWidth } : {})
    },
    hintText: {
      flex: 1,
      lineHeight: 18,
      color: theme.colors.onSurfaceVariant
    }
  });
